/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationWarrantyClaimsGetWarrantyClaimResponse { 
    id?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    comment?: string | null;
    isProcessed?: boolean;
}

